import {AnyEvent, JOB_SECTION_UPDATED, JobSectionUpdatedEvent} from '../type';

export default function jobSectionUpdated(payload: JobSectionUpdatedEvent['payload']): AnyEvent {
  return {
    type: JOB_SECTION_UPDATED,
    payload,
  }
}